<template>
    <v-sheet>
        <v-row no-gutters align="center" class="mb-10 flex-md-row-reverse">
            <v-col v-if="hasAbroadOption" cols="12" md="auto" class="mb-12 mb-md-0 pl-md-10">
                <v-checkbox v-bind="isAbroadAttrs" :class="{ [`${isAbroadAttrs?.className || ''}`]: true, 'mb-n14': !isAbroad }" v-model="isAbroad" label="해외 근무지" @change="() => (isAbroad ? ((postcode = null) || true) && ((address1 = null) || true) && ((address2 = null) || true) && emit() : emit())" persistent-hint :hint="isAbroad ? '근무지 상세주소에 전체주소를 입력해주세요' : undefined" />
            </v-col>
            <v-col>
                <v-text-field v-model="postcode" readonly :disabled="isAbroad" @click="search" :label="label ? `${label} 우편번호` : '우편번호'" :class="$attrs.className" v-bind="{ ...$attrs }" hide-details>
                    <template #append-outer>
                        <v-btn v-bind="btnAttrs" :class="`${btnAttrs?.className}`" :disabled="isAbroad" @click="search">검색</v-btn>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
        <v-text-field v-model="address1" readonly :disabled="isAbroad" @click="search" :label="label ? `${label} 기본주소` : '기본주소'" :class="$attrs.className + ' mb-10'" v-bind="{ ...$attrs }" hide-details />
        <v-text-field v-model="address2" :label="label ? `${label} 상세주소` : '상세주소'" :class="$attrs.className" v-bind="{ ...$attrs, rules }" @input="emit" />
        <daum-postcode ref="daum-postcode" @change="processAddressData" />
    </v-sheet>
</template>

<script>
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
export default {
    components: {
        DaumPostcode,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // user
        label: { type: String, default: "" },
        btnAttrs: { type: Object, default: () => ({}) },
        isAbroadAttrs: { type: Object, default: () => ({}) },
        hasAbroadOption: { type: Boolean, default: false },
    },
    data: () => ({
        postcode: null,
        address1: null,
        address2: null,
        isAbroad: false,
    }),
    computed: {
        rules() {
            if (!this.isAbroad) return [() => (!!this.postcode && !!this.address1 && !!this.address2) || "주소를 입력해주세요"];
            else return undefined;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.postcode = this.value?.postcode || null;
            this.address1 = this.value?.address1 || null;
            this.address2 = this.value?.address2 || null;

            if (this.hasAbroadOption) {
                this.isAbroad = this.value?.isAbroad || null;
            }
        },
        emit() {
            const { postcode, address1, address2, isAbroad } = this;

            const form = { ...this.value, postcode, address1, address2, isAbroad };
            if (!this.hasAbroadOption) delete form.isAbroad;

            this.$emit("input", form);
        },
        search() {
            this.$refs["daum-postcode"]?.open?.();
        },
        processAddressData({ postcode, address }) {
            this.postcode = postcode;
            this.address1 = address;
            this.emit();
        },
    },
};
</script>
